import devConfig from './config/config.dev.json';
import prodConfig from './config/config.prod.json';
import stageConfig from './config/config.stage.json';

interface Config {
  apiUrl: string;
  env: string;
  placesApiKey: string;
  isLive: boolean;
}

let env = process.env.REACT_APP_ENVIRONMENT.trim().toLowerCase();
let config: Config;

if (env === 'live') {
  config = { ...prodConfig };
} else if (env === 'test') {
  config = { ...stageConfig };
} else {
  config = { ...devConfig };
}

export const getConfig = (key: keyof Config) => {
  if (key in config && config[key] !== '') {
    return config[key] as string;
  }

  throw new Error(`Configuration variable ${key} in not set`);
};
